import { ladeDokumentHerunter, signedUrlFuerDokument } from '../../services/projektDokumenteService';
import { ProjektDokument } from './types';

/**
 * Die beiden Wege, ein abgelegtes Dokument in die Haende des Anwenders zu
 * bekommen. Bewusst hier und nicht im Service: beide fassen den Browser an
 * (neues Fenster, Objekt-URL) und sind damit keine reine Datenzugriffsschicht
 * mehr — und bewusst nicht in der Komponente, weil Liste und eingebettete
 * Modulleiste sie beide brauchen.
 */

/**
 * Ansehen: signierte URL ziehen und in einem neuen Tab oeffnen.
 *
 * `window.open` VOR dem `await` waere die uebliche Empfehlung gegen den
 * Popup-Blocker — hier steht es bewusst danach: das leere Fenster bliebe sonst
 * bei jedem Fehler als weisse Seite stehen, und der Anwender saehe die
 * Fehlermeldung im urspruenglichen Tab gar nicht.
 */
export const dokumentAnsehen = async (dokument: ProjektDokument): Promise<void> => {
  const url = await signedUrlFuerDokument(dokument.storage_pfad);
  window.open(url, '_blank', 'noopener,noreferrer');
};

/**
 * Herunterladen unter dem ORIGINALNAMEN.
 *
 * Ueber die signierte URL kaeme die Datei unter ihrem UUID-Namen an; der sagt
 * niemandem etwas. Deshalb der Umweg ueber den Blob und einen Objekt-URL —
 * der sofort wieder freigegeben wird, sonst haelt der Tab die Datei bis zum
 * Neuladen im Speicher.
 */
export const dokumentHerunterladen = async (dokument: ProjektDokument): Promise<void> => {
  const blob = await ladeDokumentHerunter(dokument.storage_pfad);
  const url = URL.createObjectURL(blob);
  try {
    const link = document.createElement('a');
    link.href = url;
    link.download = dokument.dateiname || 'dokument';
    document.body.appendChild(link);
    link.click();
    link.remove();
  } finally {
    URL.revokeObjectURL(url);
  }
};
